import { FilterSection } from '@/types/inventory';

export const inTransitDefaultImageUrl =
  'https://res.cloudinary.com/la-mesa-rv/image/upload/f_auto,q_auto/v1657821676/brand-assets/lamesarv/unit-in-transit_eutjhq.png';
export const noPhotoDefaultImageUrl =
  'https://res.cloudinary.com/la-mesa-rv/image/upload/v1746033953/photos-coming-soon_c5kpgr.jpg';

export const mobileFiltersClass = 'mobile-filters-button';

export const inventoryItemMinWidth = 340;

export const maxSlidesInInventorySlider = 5;

export const INVENTORY_IMAGE_WIDTH = 600;
export const INVENTORY_BIG_IMAGE_WIDTH = 600;

export const PDP_MINIATURE_WIDTH_REM = 7.5;

export const SORT_BY_SECTION = 'Sort By';

export const RANGE_FILTER_SECTIONS: Set<string> = new Set([
  FilterSection.LENGTH,
  FilterSection.PRICE,
  FilterSection.YEAR,
  FilterSection.SLEEPS,
]);

export const SEARCHABLE_FILTER_SECTIONS: Set<string> = new Set([
  FilterSection.MAKE,
  FilterSection.MODEL,
  FilterSection.FLOOR_PLAN,
  FilterSection.FEATURES,
  FilterSection.LOCATION,
]);

export const CUSTOM_RV_TYPE_SORT_PREV = ['Class A', 'Class B', 'Class C'];
export const CUSTOM_RV_TYPE_SORT_POST = ['5th Wheel', 'Travel Trailer', 'Toy Hauler'];
export const CUSTOM_RV_TYPE_SORT = [...CUSTOM_RV_TYPE_SORT_PREV, ...CUSTOM_RV_TYPE_SORT_POST];

export const ITEMS_PER_PAGE_MOBILE = 7;
export const ITEMS_PER_PAGE_TABLET = 12;

export const MAX_ITEMS_PER_PAGE = 45;

export const CUSTOM_COMES_AFTER_TAG_RECORD: Record<string, FilterSection> = {
  Chassis: FilterSection.FUEL_TYPE,
  'Drive Train': FilterSection.YEAR,
};

export const BANNER_INLINE_ELEMENTS_COUNT = 9;

export const ITEMS_TO_SKIP_BEFORE_FILLER_CARD = 4;

export const ITEMS_BETWEEN_FILLER_CARDS = {
  MOBILE: 4,
  TABLET: 5,
  DESKTOP: 8,
};

export const SLEEPS_SEARCH_PARAM_KEY = 'sleeps';
export const SLEEPING_CAPACITY_EQUIPMENT_PREFIX = 'Sleeping Capacity ';

export const FEE_INCLUSIVE_CONTENT_CARDS_DEFAULT =
  'Price includes Prep, Filing, Emission Testing, and Doc Fees. Excludes tax, title, license, and registration.';
export const FEE_INCLUSIVE_CONTENT_PDP_DEFAULT =
  "Price includes Prep, Filing Emission Testing, and Doc Fees. Excludes tax, title, license, and registration. Price is based on the unit's location.";
